import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { TodoDetailsComponent } from "./todo-details/todo-details.component";

const routes: Routes = [
    {
        path: 'todo',
        component: TodoDetailsComponent,
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class TodoRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/main/content/common/todo-tab/todo-routing.module.ts